/*
  Use this controller to sync the value of a source element (like a select)
  to the element this controller is attached to (typically a hidden input).

  The controller expects:
  - sourceIdValue: the ID of the element to watch for changes

  Example:
  <input type="hidden" data-controller="sync-value" data-sync-value-source-id-value="document_selector" />
*/
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sourceId: String }

  connect() {
    this.sourceElement = document.getElementById(this.sourceIdValue);
    if (this.sourceElement) {
      // Set initial value
      this.syncValue();

      // Listen for changes
      this.sourceElement.addEventListener("change", this.syncValue.bind(this));
    } else {
      console.warn(`Sync value: Could not find source element with ID: ${this.sourceIdValue}`);
    }
  }

  disconnect() {
    if (this.sourceElement) {
      this.sourceElement.removeEventListener("change", this.syncValue.bind(this));
    }
  }

  syncValue() {
    if (this.sourceElement) {
      this.element.value = this.sourceElement.value;
    }
  }
} 